import Vue from 'vue';
import Vuex from 'vuex';

import CDWM20200317 from '../views/20200317CDWM/store/index';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pointOut: false,
  },
  mutations: {
    changePointOut(state, data) {
      state.pointOut = data;
    },
  },
  actions: {},
  modules: {
    CDWM20200317,
  },
});
